import React, { useEffect, useRef, useState } from "react";
import { friendApplyDeal, friendApplyList } from "../../net/service";
import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { FlatList, Platform, Pressable, StyleSheet, Text, View } from "react-native";
import { color_1E1E1E, color_333333, color_999999, color_main } from "../../assets/style/colors";
import { FriendRquestSchema, NewFriendStatus, UserSchema } from "../../realm/contactSchema";
import { MainNavProps } from "../navigation/main/MainParamList";
import { CListItem } from "../Chat/CListItem";
import { getUserName } from "../Chat/chat-helper";
import { Str_NewFriend, Str_Passed, Str_Reject, Str_Rejected, Str_See } from "../../language/string_res";
import { useIsFocused } from "@react-navigation/native";
import globalEventBus from "../../utils/EventBus";
import { getAvatarByUser } from "../../utils/utils";
import { LeftView } from "../Chat/CListItem";
import { useStore } from "../../store/UserStore";

type ItemProps = {
    friend?: FriendRquestSchema,
    user?: UserSchema;
};

export const FriendApplyList = ({ navigation }: MainNavProps<"FriendApplyList">) => {
    const [friendList, setFriendList] = useState<ItemProps[]>([]);
    const useIsFoucs = useIsFocused()
    const page = useRef(0)
    const isHadNextPage = useRef(true)
    const [isRefreshing, setIsRefreshing] = useState(false)
    const { state } = useStore();

    useEffect(() => {
        if (useIsFoucs) {
            if (friendList.length === 0 && isHadNextPage.current === true) {
                loadData(false)
            }
        }
    }, [useIsFoucs]);

    const loadData = (isRefresh: boolean) => {
        if (isRefresh) {
            page.current = 0;
            isHadNextPage.current = true;
            setIsRefreshing(true)
        } else {
            if (isHadNextPage.current === false) {
                return
            }
        }

        friendApplyList({ skip: page.current * 100, limit: 100 })
            .then((data) => {
                if (data.data) {
                    const { friendRequests, users } = data.data;

                    const newFriends: ItemProps[] = [];
                    if (friendRequests && friendRequests.length > 0) {
                        for (let i = 0; i < friendRequests.length; i++) {
                            const friend = friendRequests[i];
                            const u = users.find((v: any) => v.uid === friend.applyUid);
                            newFriends.push({ user: u, friend: friendRequests[i] });
                        }
                    }
                    if (newFriends && newFriends.length > 0) {
                        newFriends.sort((a, b) => {
                            const aTime = a?.friend?.applyTime ?? 0;
                            const bTime = b?.friend?.applyTime ?? 0;
                            return aTime > bTime ? -1 : 1;
                        });
                        setFriendList(newFriends);
                    }

                    isHadNextPage.current = (friendRequests?.length ?? 0) < 100;
                }
            }).catch(err => {

            }).finally(() => {
                endRefreshing()
            })
    }

    function endRefreshing() {
        setIsRefreshing(false)
    }

    const itemClick = (item: ItemProps) => {
        if (Platform.OS === 'web') {
            globalEventBus.emit('ShowWebDetail', {
                screenName: 'ContactInfo',
                params: { current: { ...item.friend, ...item.user, }, type: 'NEW_FRIEND' }
            });
        } else {
            navigation.navigate('ContactInfo', { current: { ...item.friend, ...item.user, }, type: 'NEW_FRIEND' })
        }
    };
    const handleVerifyClick = (item: ItemProps) => {
        friendApplyDeal({ applyUid: item.user?.uid, op: "refuse" }).then((resp) => {
            if (resp && resp.code === 0) {
                setFriendList((prev) => {
                    let data = prev?.map(v => {
                        if (v.user?.uid === item.user?.uid) {
                            if (v.friend) {
                                v.friend.status = NewFriendStatus.REFUSE
                            }
                        }
                        return v;
                    });
                    return data
                })
            }
        });
    };
    const ItemRight = (item: ItemProps) => {
        const isMyFriend = state?.contactList?.find(v => v.uid === item.user?.uid);

        if (isMyFriend || item?.friend?.status === NewFriendStatus.PASS) {
            return (
                <View style={styles.statusTag}>
                    <Text style={styles.statusTagText}>{Str_Passed}</Text>
                </View>
            );
        }
        if (item?.friend?.status === NewFriendStatus.REFUSE) {
            return (
                <View style={styles.statusTag}>
                    <Text style={styles.statusTagText}>{Str_Rejected}</Text>
                </View>
            );
        }
        return (
            <View style={styles.actionButtons}>
                <Pressable 
                    style={[styles.actionButton, styles.rejectButton]} 
                    onPress={(e) => {
                        e.stopPropagation(); // 阻止事件冒泡到父级 Pressable
                        handleVerifyClick(item);
                    }}
                    android_ripple={{ color: 'rgba(255, 255, 255, 0.2)' }}
                >
                    <Text style={styles.rejectButtonText}>{Str_Reject}</Text>
                </Pressable>
                <Pressable 
                    style={[styles.actionButton, styles.viewButton]} 
                    onPress={(e) => {
                        e.stopPropagation(); // 阻止事件冒泡到父级 Pressable
                        itemClick(item);
                    }}
                    android_ripple={{ color: 'rgba(255, 255, 255, 0.2)' }}
                >
                    <Text style={styles.viewButtonText}>{Str_See}</Text>
                </Pressable>
            </View>
        );
    };

    function renderNewFriendItem({ item, index }: { item: ItemProps, index: number }) {
        const avatarData = getAvatarByUser(item.user as UserSchema);
        const isProcessed = item?.friend?.status === NewFriendStatus.PASS || item?.friend?.status === NewFriendStatus.REFUSE;
        
        return (
            <Pressable
                style={styles.friendCard}
                onPress={() => itemClick(item)}
                android_ripple={{ color: 'rgba(0, 0, 0, 0.05)' }}
            >
                <View style={styles.cardContent}>
                    {/* 头像 */}
                    <View style={styles.avatarContainer}>
                        <LeftView left={avatarData} size={56} isRounded={true} isGroup={false} style={{ marginRight: 0 }} />
                    </View>
                    
                    {/* 中间内容 */}
                    <View style={styles.contentContainer}>
                        <Text 
                            ellipsizeMode="tail"
                            numberOfLines={1}
                            style={styles.userName}
                        >
                            {getUserName(item.user)}
                        </Text>
                        {item.friend?.hello ? (
                            <Text
                                style={styles.messageText}
                                ellipsizeMode="tail"
                                numberOfLines={2}
                            >
                                {item.friend?.hello}
                            </Text>
                        ) : (
                            <Text style={styles.emptyMessageText}>暂无留言</Text>
                        )}
                    </View>
                    
                    {/* 右侧操作 */}
                    <View style={styles.rightContainer}>
                        <ItemRight {...item} />
                    </View>
                </View>
            </Pressable>
        );
    }

    const renderEmpty = () => {
        return (
            <View style={styles.emptyContainer}>
                <Text style={styles.emptyText}>暂无新的好友申请</Text>
            </View>
        );
    };

    return (
        <BaseScreen>
            <NavBar title={Str_NewFriend} showBack={Platform.OS !== 'web'} />
            <FlatList
                data={friendList}
                style={styles.listContainer}
                contentContainerStyle={styles.listContent}
                refreshing={isRefreshing}
                onRefresh={() => { loadData(true) }}
                onEndReached={() => { loadData(false) }}
                renderItem={renderNewFriendItem}
                ListEmptyComponent={renderEmpty}
                keyExtractor={(item, index) => item.user?.uid?.toString() ?? index.toString()}
                showsVerticalScrollIndicator={false}
            />
        </BaseScreen>
    );
};

const styles = StyleSheet.create({
    listContainer: {
        flex: 1,
        backgroundColor: '#F5F5F5',
    },
    listContent: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 20,
    },
    friendCard: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        marginBottom: 12,
        overflow: 'hidden',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 8,
        elevation: 3,
    },
    cardContent: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
    },
    avatarContainer: {
        marginRight: 12,
    },
    contentContainer: {
        flex: 1,
        justifyContent: 'center',
        marginRight: 12,
    },
    userName: {
        fontSize: 16,
        fontWeight: '600',
        color: '#1A1A1A',
        marginBottom: 6,
        letterSpacing: 0.2,
    },
    messageText: {
        fontSize: 14,
        color: '#666666',
        lineHeight: 20,
    },
    emptyMessageText: {
        fontSize: 13,
        color: '#999999',
        fontStyle: 'italic',
    },
    rightContainer: {
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    actionButtons: {
        flexDirection: 'row',
        gap: 8,
    },
    actionButton: {
        borderRadius: 20,
        paddingHorizontal: 16,
        paddingVertical: 8,
        minWidth: 60,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
    },
    rejectButton: {
        backgroundColor: '#FF4444',
    },
    rejectButtonText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '600',
    },
    viewButton: {
        backgroundColor: '#4CAF50',
    },
    viewButtonText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '600',
    },
    statusTag: {
        backgroundColor: '#F0F0F0',
        borderRadius: 16,
        paddingHorizontal: 12,
        paddingVertical: 6,
        minWidth: 60,
        alignItems: 'center',
        justifyContent: 'center',
    },
    statusTagText: {
        color: '#999999',
        fontSize: 13,
        fontWeight: '500',
    },
    emptyContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 100,
        paddingBottom: 100,
    },
    emptyText: {
        fontSize: 15,
        color: '#999999',
        textAlign: 'center',
    },
});
